/* eslint-disable no-console */
// 桥接核心实现，添加客户端api

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _constant = require('./constant');

var _constant2 = _interopRequireDefault(_constant);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {string} apiName  api名称
 * @param {Function} success  接口调用成功的回调函数
 * @param {Function} error 接口调用失败的回调函数
 * @param {Boolean} shouldRemoveOnComplete  接口调用后是否移除回调的参数
 * @param {Number} timeout 接口超时时长，单位是ms
 * @param  {boolean} shouldWait 等待时长
 */
function createCallback(apiName, success, error, shouldRemoveOnComplete, timeout, shouldWait) {
    var successName = 'suiSuccess_' + apiName + '_' + _constant2.default.native.account,
        errorName = 'suiError_' + apiName + '_' + _constant2.default.native.account;
    var timer = void 0;

    if (!shouldWait) {
        timer = setTimeout(function () {
            _constant2.default.native[errorName]({
                code: 0xFF03,
                msg: 'Api apply timeout'
            });
        }, timeout || 30000);
    }

    if (typeof success === 'function') {
        _constant2.default.native[successName] = function () {
            clearTimeout(timer);
            if (_constant2.default.native.debugMode) {
                console.log('success callback entry. callback name: ' + successName);
                console.log('the client callback params:');
            }

            for (var _len = arguments.length, parameters = Array(_len), _key = 0; _key < _len; _key++) {
                parameters[_key] = arguments[_key];
            }

            success.apply(this, parameters);
            if (shouldRemoveOnComplete) {
                _utils2.default.clear(_constant2.default.native, successName, errorName);
            }
        };
    }
    if (typeof error === 'function') {
        _constant2.default.native[errorName] = function () {
            clearTimeout(timer);
            if (_constant2.default.native.debugMode) {
                console.log('error callback entry. callback name: ' + errorName);
                console.log('the client callback params:');
            }

            for (var _len2 = arguments.length, parameters = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                parameters[_key2] = arguments[_key2];
            }

            error.apply(this, parameters);
            if (shouldRemoveOnComplete) {
                _utils2.default.clear(_constant2.default.native, successName, errorName);
            }
        };
    }
    _constant2.default.native.account++;
    return {
        successID: 'sui.native.' + successName,
        errorID: 'sui.native.' + errorName
    };
}

/**
 * 挂载接口及调用接口的方法
 * @param  {function} stream [请求协议路径]
 * @param  {object} config [配置项]
 * @param  {object} callBackIds [回调方法名对象]
 */
function invoke(stream, config, callBackIds) {
    if (_constant2.default.native.debugMode) {
        console.log('applying client api \'' + stream + '\' with the config like:');
    }
    var callArr = {
        success: callBackIds.successID.split('.'),
        error: callBackIds.errorID.split('.')

    };

    if (callArr.success.length < 3) {
        throw new ReferenceError('sui-sdk\u6210\u529F\u56DE\u8C03\u65B9\u6CD5\u5B9A\u4E49\u9519\u8BEF,\u63A5\u53D7\u5F62\u5F0F\uFF1Asui.native.functionName\uFF0C\u5F53\u524DsuccessName:' + callBackIds.successID, callBackIds.successID);
    }
    if (callArr.error.length < 3) {
        throw new ReferenceError('sui-sdk\u5931\u8D25\u56DE\u8C03\u65B9\u6CD5\u5B9A\u4E49\u9519\u8BEF,\u63A5\u53D7\u5F62\u5F0F\uFF1Asui.native.functionName\u65B9\u6CD5\uFF0C\u5F53\u524DerrorName:' + callBackIds.errorID, callBackIds.errorID);
    }
    var successName = callArr.success[callArr.success.length - 1];
    var errorName = callArr.error[callArr.error.length - 1];

    if (typeof _constant2.default.native[successName] !== 'function') {
        var errorNative = (0, _stringify2.default)(_constant2.default.native);

        throw new ReferenceError('sui-sdk\u6210\u529F\u56DE\u8C03\u65B9\u6CD5\u4E22\u5931,\u53EA\u63A5\u53D7function\u65B9\u6CD5\u3002sui.native:' + errorNative, callBackIds.successID);
    }
    if (typeof _constant2.default.native[errorName] !== 'function') {
        var _errorNative = (0, _stringify2.default)(_constant2.default.native);

        throw new ReferenceError('sui-sdk\u5931\u8D25\u56DE\u8C03\u65B9\u6CD5\u4E22\u5931,\u53EA\u63A5\u53D7function\u65B9\u6CD5\u3002sui.native:' + _errorNative, callBackIds.successID);
    }
    _utils2.default.callUrl(_constant2.default.native, stream, _utils2.default.dataFormate(config), callBackIds.successID, callBackIds.errorID);
}

/**
 * 挂载客户端接口调用的方法。
 */
function createAPI() {
    var _loop = function _loop(apiName) {
        _constant2.default[apiName] = function () {
            var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // eslint-disable-next-line no-empty-function
            var success = config.success || function () {},

            // eslint-disable-next-line no-empty-function
            error = config.error || function () {},
                shouldRemoveOnComplete = config.shouldRemoveOnComplete === undefined ? true : config.shouldRemoveOnComplete,
                timeout = config.timeout,
                shouldWait = config.waitUserAction;
            var callBackIds = createCallback(apiName, success, error, shouldRemoveOnComplete, timeout, shouldWait);

            delete config.success;
            delete config.error;
            invoke(_constant2.default.native.apiList[apiName], config, callBackIds);
        };
    };

    for (var apiName in _constant2.default.native.apiList) {
        _loop(apiName);
    }
}

/**
 * 获取当前支持的接口的方法
 */
function getSupport() {
    if (!_utils2.default.sdkEnable()) {
        return;
    }
    var support = {
        successName: 'onGetSuiSopportAPISuccess',
        errorName: 'onGetSuiSopportAPIError',

        /**
         * @param {*} res 查询api完成的回调
         */
        success: function success(res) {
            if (typeof res === 'string') {
                res = JSON.parse(res);
            }
            if (res.code === 0) {
                delete res.result.apiMap['config'];
                _constant2.default.native.apiList = res.result.apiMap;
                _constant2.default.whiteList = res.result.inWhiteList;
                _constant2.default.version = res.result.version;
                _constant2.default.native.suiStatus.state = 2; // 状态已准备
                _constant2.default.native.suiStatus.detail = 'getSupportAPISuccess';
                createAPI();
                _constant2.default.native.waitingConf.complete();
                _utils2.default.clear(_constant2.default.native, support.successName, support.errorName);
            }
        },

        /**
         * @param {*} err 查询api失败的回调
         */
        error: function error(err) {
            if (err.code === 0xFF04) {
                return;
            } else {
                _constant2.default.native.suiStatus.state = 2; // 状态已准备
                _constant2.default.native.suiStatus.detail = res.msg;
            }
            _utils2.default.clear(_constant2.default.native, support.successName, support.errorName);
        }
    };

    _constant2.default.native[support.successName] = support.success;
    _constant2.default.native[support.errorName] = support.error;
    _utils2.default.callUrl(_constant2.default.native, 'sui-js-call://getSupportAPIMap', '', 'sui.native.' + support.successName, 'sui.native.' + support.errorName);
}

exports.default = {
    getSupport: getSupport
};